import Vue from 'vue'
import App from './App.vue'
import { router } from './router/index'
import store from '@/store/index'
import registerGlobalComponents from './plugins/register-components'
import '@/styles/index.scss' // global css
import '@/styles/animate.min.css'
import '@/plugins/index.js'
import ElementUI from 'element-ui'
ElementUI.Dialog.props.closeOnClickModal.default = false;

import 'element-ui/lib/theme-chalk/index.css'
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)
Vue.use(ElementUI, { zIndex: 3000 })
registerGlobalComponents()
Vue.config.productionTip = false

// 保证组件css层级高于iview层级
import {Lazyload} from 'vant';
// options 为可选参数，无则不传
Vue.use(Lazyload, {
  lazyComponent: true,
  loading: '',
  error: ''
});

import ViewUI from 'view-design';
import '@vant/touch-emulator';
import 'view-design/dist/styles/iview.css'
Vue.use(ViewUI, {
  transfer: true
});
Vue.prototype.process = { env: Object.assign({}, process.env) };
new Vue({
  render: h => h(App),
  beforeCreate() {
    Vue.prototype.$bus = this
  },
  router,
  store
}).$mount('#app')
